import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import * as styles from '@/components/form/form.module.scss'
import FormContext from '@/components/form/form-context'

type Props = {
  id: string
  label: string
  required?: boolean
  align?: 'leftLabel' | 'centerLabel' | 'item'
}
const TextField: React.FC<Props> = ({
  id,
  label,
  required,
  align = 'item'
}) => {
  const {
    formState: { errors },
    register
  } = useFormContext()
  const formContext = useContext(FormContext)
  return (
    <div
      className={[styles[align], formContext?.classes?.input]
        .filter(Boolean)
        .join(' ')}
    >
      <label htmlFor={id}>
        {label}
        {required === true ? '*' : ''}
      </label>
      <div>
        <input type="text" {...register(id)} data-testid={id} />
        {errors[id] && <span>Please, select a {label}</span>}
      </div>
    </div>
  )
}
export default TextField
